import React from "react";
import Lottie from "react-lottie";
import "./Successfull_Lottie.css";
import * as animationData from "./Successfull_Lottie.json";

function Successfull_Lottie(props) {
  const defaultOptions = {
    loop: true,
    autoplay: true,
    animationData: animationData,
    rendererSettings: {
      preserveAspectRatio: "xMidYMid slice",
    },
  };

  return (
    <section className="main">
      <div className="success_div">
        <div>
          <div className="Successfull_Lottie_icon">
            <Lottie
              className="me-auto"
              options={defaultOptions}
            />
          </div>
        </div>
        <p className="success_text">{props?.successText}</p>
      </div>
    </section>
  );
}
export default Successfull_Lottie;
